import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';
import { Grid } from 'components/PageContent/styles';

export const FormContainer = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1.875),
  alignItems: 'center',
  justifyContent: 'end',
  width: '60%',

  '& .MuiInputBase-root': {
    fontSize: theme.typography.h5.fontSize,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 6,

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.black10.main,
    },

    '& .MuiTypography-root': {
      fontSize: theme.typography.h5.fontSize,
    },
  },
}));

export const SortLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.body1.fontWeight,
  textAlign: 'right',
}));

export const FilterContainer = styled(Grid)({
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: 'auto',
});

export const SortIcon = styled('img')({
  width: 27,
  height: 27,
});

export const ButtonWithIcon = styled(IconButton)({
  padding: 0,

  '&:hover': {
    backgroundColor: 'transparent',
  },
});
